import { normalizeAbsolute } from "./path";
import { router } from "./router";

export function active(
  node: HTMLElement,
  config: { classActive: string; classInactive: string; exact: boolean; path: string },
) {
  const path = normalizeAbsolute(config.path);

  return {
    destroy: router.currentPath.subscribe((currentPath) => {
      const active = config.classActive.length == 0 ? [] : config.classActive.split(" ");
      const inactive = config.classInactive.length == 0 ? [] : config.classInactive.split(" ");

      let matches = config.exact ? currentPath == path : currentPath.startsWith(path);
      if (matches) {
        node.classList.add(...active);
        node.classList.remove(...inactive);
      } else {
        node.classList.add(...inactive);
        node.classList.remove(...active);
      }
    }),
  };
}
